<template>
    <div class="progress mb-2" style="height: 1em;" v-show="isUploading">
        <div role="progressbar" id="progressBar" aria-valuemin="0" aria-valuemax="100" class="progress-bar bg-success" :style="'width:' + progress + '%'">{{ progress }}%</div>
    </div>
</template>

<script>
export default {
    props: {
        for: {
            type: String,
        },
    },
    data() {
        return {
            key: null,
            element: null,
            isUploading: false,
            progress: 0,
        };
    },
    methods: {
        init(tries) {
            if (tries > 5) {
                return;
            }

            this.$nextTick(function () {
                this.element = document.querySelector(this.for);

                if (!this.element) {
                    return this.init(tries++);
                }
                this.element.removeEventListener('livewire-upload-start', this.start);
                this.element.removeEventListener('livewire-upload-progress', this.update);
                this.element.removeEventListener('livewire-upload-error', this.stop);
                this.element.removeEventListener('livewire-upload-finish', this.stop);

                this.element.addEventListener('livewire-upload-start', this.start);
                this.element.addEventListener('livewire-upload-progress', this.update);
                this.element.addEventListener('livewire-upload-error', this.stop);
                this.element.addEventListener('livewire-upload-finish', this.stop);
            });
        },
        start() {
            Vue.set(this, 'isUploading', true);
            Vue.set(this, 'progress', 0);
        },
        stop() {
            Vue.set(this, 'isUploading', false);
        },
        update(e) {
            Vue.set(this, 'progress', e.detail.progress);
        },
    },
    watch: {
        for: {
            immediate: true,
            handler() {
                this.init(1);
            },
        },
    },
};
</script>
